@import 'styles/variables';
@import 'styles/mixins.scss';

.warningBox {
  @include body-md-text;

  background-color: $orange-10;
  border-radius: 4px;
  color: $gray-90;
  display: flex;
  margin-bottom: 8px;
  padding: 16px;

  svg {
    flex-shrink: 0;
    margin: 4px 16px 0 0;

    * {
      fill: $orange-50;
    }
  }

  p {
    margin-bottom: 8px;
  }
  p:last-child {
    margin-bottom: 0;
  }
}
